import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AddCrossIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import { useExpensesTotalInfo } from "~/repository/useExpensesTotalInfo.js";
import TrackedExpense from "./TrackedExpense.jsx";
import { ExpenseListModal } from "../Expenses/ExpenseListModal.js";
import { ExpenseModal } from "../Expenses/ExpenseModal.js";

const ExpenseTracking = ({ parentId, projectId, isLoggedUserClient }) => {
  const { t } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [openListModal, setOpenListModal] = useState(false);
  const { data } = useExpensesTotalInfo("Task", parentId);
  const total = Number(data?.yours) + Number(data?.others);

  const handleFormOpen = () => setFormOpen(true);
  const handleFormClose = () => setFormOpen(false);

  const handleOpenListModal = () => setOpenListModal(true);
  const handleCloseListModal = () => setOpenListModal(false);

  useEffect(() => {
    if (!total && openListModal) {
      handleCloseListModal();
    }
  }, [openListModal, total]);

  return (
    <div className="c-pill-box">
      <div className="c-pill-box__header">
        {!isLoggedUserClient && (
          <button
            className="c-pill-box__btn-cta tw-bg-transparent tw-border-0 tw-text-secondary tw-p-0 tw-cursor-pointer focus:tw-outline-none"
            onClick={handleFormOpen}
          >
            <AddCrossIcon className="tw-mr-1 tw-fill-current" /> {t("Expense")}
          </button>
        )}
        <TrackedExpense
          projectId={projectId}
          total={total}
          isLoggedUserClient={isLoggedUserClient}
          onOpenListModal={handleOpenListModal}
          parentId={parentId}
        />
        <ExpenseModal
          open={formOpen}
          onClose={handleFormClose}
          projectId={projectId}
          taskId={parentId}
          displaySuccessToast={false}
        />
        {openListModal && (
          <ExpenseListModal
            taskId={parentId}
            projectId={projectId}
            open={openListModal}
            onClose={handleCloseListModal}
          />
        )}
      </div>
    </div>
  );
};

ExpenseTracking.displayName = `ExpenseTracking`;

ExpenseTracking.propTypes = {
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  isLoggedUserClient: PropTypes.bool.isRequired,
};

export default ExpenseTracking;
